import React, {useState, useEffect} from "react"
import puzzleAnswerData from "../puzzleAnswerData"

function LockPick(props) {
    const [lockOneZone] = useState(puzzleAnswerData[1].zoneOne)
    const [lockTwoZone] = useState(puzzleAnswerData[1].zoneTwo)
    const [errorMessage, setErrorMessage] = useState(false)
    const [sliderValues, setSliderValues] = useState({
        lockPickOne: 100,
        lockPickTwo: 250,
    })
    
    function handleChange(event) {
        const {value, name, id} = event.target
        setSliderValues({
            ...sliderValues,
            [id]: value
        })
        
        const transform = "translate(-50%, -50%) rotate(" + value +"deg)"
        document.getElementById(name).style.transform = transform
    }
    
    function handleClick() {
        const {lockPickOne, lockPickTwo} = sliderValues
        if ( lockPickOne > lockOneZone.min && lockPickOne < lockOneZone.max && lockPickTwo > lockTwoZone.min && lockPickTwo < lockTwoZone.max){
            props.callBackPuzzleUpdate("lockPick")
            props.callBackKeypad()
            
            const show = "on"
            const text = "The cabinet springs open and Larry takes a closer look. Out of the corner of his eye he spots a smudge on the glass... a fingerprint!"
            const trigger = "lockPick"
            props.callBackOverlay(show, text, trigger)
        } else {
            setErrorMessage(true)
            setTimeout(() => setErrorMessage(false), 3000)
        }
    }
    
    useEffect(() => {
        if (errorMessage) {
            document.getElementById("error").style.visibility = "visible"
        } else {
            document.getElementById("error").style.visibility = "hidden"
        }
    },[errorMessage])
    
    return (
        <div id="lockPickPuzzle">
            <div id="lockPickVisual">
                <div className="lockPickWrapper" id="lockPickVisualOne">
                    <div className="lockPickVisual" id="redLockPick"></div>
                </div>
                <div className="lockPickWrapper" id="lockPickVisualTwo">
                    <div className="lockPickVisual" id="blueLockPick"></div>
                </div>
            </div>
            <div id="lockPickControl">
                <h3>If no one knows where the key is then Larry will need to improvise. Help Larry find the right positions for his lockpicks.</h3>
                <label>Lock Pick One
                    <input type="range" min="6" max="361" className="lockPickSliders" name="lockPickVisualOne" id="lockPickOne" value={sliderValues.lockPickOne} onChange={handleChange} />
                </label><br />
                <label>Lock Pick Two
                    <input type="range" min="6" max="361" className="lockPickSliders" name="lockPickVisualTwo" id="lockPickTwo" value={sliderValues.lockPickTwo} onChange={handleChange}/>
                </label><br />
                <button className="standardButton" onClick={handleClick}>Submit</button>
                <h2 id="error">No luck! Try again.</h2>
            </div>
        </div>
    )
}

export default LockPick